import React, { useState } from 'react';
import { v4 as uuidv4 } from "uuid"
import Cookies from "universal-cookie"
import SearchList from './SearchList';
import { Link } from "gatsby"
import FloorPlanModal from "./floorPlanModal"
import VideoPlay from "../Play/property-results-video"
import PropertyBox from '../property-box/property-box';
import { Col, Container, Row } from "react-bootstrap";
// import parse from "html-react-parser"
import moment from "moment"
import { currencyFormat } from '@components/common/utils';
import ContentBlock from "../content/Content";
import Card from "../card/card"
import classNames from "classnames"
import noImg from "../../images/no-image.png"
import LinkIcon from "../link-icon/link-icon"
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import imageConfig from "../../../static/images/config.json"
import PriceComp from "@components/Property/Price"
import Modal from 'react-bootstrap/Modal';
import BookAViewingForm from "../../Forms/BookAViewing"
import CardLet from '../news-lettings/card-let';
import AuctionCalloutBanner from '../callout-banner/auction-callout-banner';
import Noimg from "../../components/no-img/Noimg"
let text_truncate = function (str, length, ending) {
  length = 150;
  //

  if (ending == null) {
    ending = '...';
  }

  if (str?.length > length) {
    return str?.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

const mycookies = new Cookies()
const InfiniteHits = ({
  hits,
  // hasPrevious,
  // refinePrevious,
  // hasMore,
  // refineNext,
  // location,
  tag,
  source,
  map,
  type,
  department,
  auctionType,
  // userObjects,
}) => {
  const [showForm, setShowForm] = useState(false);
  const [index, setIndex] = useState(null);
  const openform = (i) => {
    if (index === i) {
      setShowForm(!showForm)
      setIndex(null)
    }
    else {
      setShowForm(!showForm)
      setIndex(i)
    }
  }
  return (
    <Row className="news-lettings__row flex-column flex-md-row">
      {hits?.map((hitItem, i) => {
        // property details url structure

        let uriStr = "auction-property-for-sale/"
        let mysale = ""
        let hit = { ...hitItem }
        // mapping
        hit.searchType = hit.searchType || hit.search_type;

        if (hit.searchType === "sales" && hit.department === "residential") {
          uriStr = `auction-property-for-sale/`
          mysale = `myResSaleProp`
        } else if (
          hit.searchType === "lettings" &&
          hit.department === "residential"
        ) {
          uriStr = `property-to-rent/`
          mysale = `myResRentProp`
        }

        if (tag === "sold") {
          uriStr = `property-sold/`
          mysale = `myResSaleProp`
        } else if (tag === "let") {
          uriStr = `property-let/`
          mysale = `myResRentProp`
        }

        let url_one = ""
        let photoplans = false

        if (hit.virtual_tour) {
          url_one = String(hit.virtual_tour)
          photoplans = url_one.indexOf("photoplans.planup") > -1
        }
        // property details url structure
        if (department === 'newhomes') {
          hit.price_qualifier = 'Price from';
          uriStr = 'new-homes/current-developments-details/';
          hit.bedroom = hit.title;

          //remove html tags from a string, leaving only the inner text
          function removeHTML(str) {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = str;
            return tmp.textContent || tmp.innerText || "";
          }

          hit.description = removeHTML(hit.description)
        }
        return (
          <>

            {i % 8 === 0 && i !== 0 &&
              <AuctionCalloutBanner addShell={false} />
            }
            <Col
              className={classNames("property-card mysingleproperty news-lettings__col", {
                // "d-none d-lg-block": index >= 2,
              })}
              id={`item${hit.objectID}`}
              data-objectid={`item${hit.objectID}`}
              data-lat={hit?._geoloc?.lat}
              data-lng={hit?._geoloc?.lng}
              key={hit.title}
            >
              <Card className="card-let">
                <Link
                  //  target={"_blank"} 
                  //  to={`https://strakers.azurewebsites.net/auctions?lid=${hit?.crm_id}`}
                  onClick={() => { sessionStorage.setItem('searchindex', hit.objectID) }} to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                >
                  {hit?.status === "Sold" ?
                    <div className={hit?.status === "Sold Subject To Contract" || hit?.status === "Let Agreed" ? "property-box__badge yellow" : "property-box__badge"}>{hit?.status} {hit?.sale_price && `for £${hit?.sale_price?.toLocaleString()}`}</div>
                    :
                    <div className={hit?.status === "Sold Subject To Contract" || hit?.status === "Let Agreed" ? "property-box__badge yellow" : "property-box__badge"}>{hit?.status}</div>
                  }

                  {/* <Card.Head image={image} alt="property" /> */}
                  {hit?.images1 && hit?.images1[0] ?
                    <ShowProcessedImage
                      images={hit?.images1[0]}
                      attr={{ className: '', alt: `${hit?.display_address ? hit?.display_address : ""} - Strakers Estate Agents` }}
                      transforms={imageConfig.property.searchResults2.sizes} />
                    :
                    // <img src={noImg} />
                    <Noimg imagename="coming-soon-image.Image.searchResults2" />
                  }
                </Link>
                <Card.Body>
                  <Link
                    //  target={"_blank"} 
                    //  to={`https://strakers.azurewebsites.net/auctions?lid=${hit?.crm_id}`}
                    onClick={() => { sessionStorage.setItem('searchindex', hit.objectID) }} to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                  >
                    <Row className="g-0 align-items-center">
                      <Col>
                        {hit?.lotNumber &&
                          <h3>Lot {hit?.lotNumber}</h3>
                        }
                      </Col>
                      <Col xs="auto">
                        <p className="fw-bolder">{hit?.auctionDate ? moment(hit?.auctionDate).format("DD MMMM YYYY") : ""}</p>
                      </Col>
                    </Row>

                    <div className="card-let__price">
                      <span className="text-uppercase d-inline-block">
                        *Guide Price <span className="fw-bolder">{hit?.guidePrice}</span> Plus Fees
                      </span>
                    </div>
                    <h4>
                      <Link
                        // target={"_blank"} to={`https://strakers.azurewebsites.net/auctions?lid=${hit?.crm_id}`}
                        onClick={() => { sessionStorage.setItem('searchindex', hit.objectID) }} to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                      >
                        {hit.display_address}
                      </Link>
                    </h4>
                    {/* {hit.title && <p className="card-let__description">{hit.title}</p>} */}
                  </Link>
                </Card.Body>
                {auctionType === "past" ? null :
                  <Card.Footer>
                    <Row className="g-0 justify-content-between">
                      <Col>
                        <Link
                          className='link-icon__text fw-bolder d-flex align-items-center auction-list-det-bid'
                          onClick={() => { sessionStorage.setItem('searchindex', hit.objectID) }} to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                        >
                          <div
                            className={`link-icon__text fw-bolder fz14 position-relative order-0 det-bid-auction`}
                          >
                            Details/Bid
                          </div>
                          <i className={classNames(`icon icon--eye`)}></i>
                        </Link>
                        {/* <LinkIcon href={`https://strakers.azurewebsites.net/auctions?lid=${hit?.crm_id}`} Link_Type={"External_url"} text="Details/Bid" icon="eye" /> */}
                      </Col>

                      <Col>
                        {hit.legalDocumentUrl &&
                          <LinkIcon href={`/${uriStr}${hit.slug}-${hit.objectID}`} Link_Type={"Internal_url"} text="Legal Docs" icon="file" />
                        }
                      </Col>
                    </Row>
                  </Card.Footer>}
              </Card>
            </Col>
          </>)
      })}
    </Row>
  )
}

export default InfiniteHits;
